import { motion } from "framer-motion";
import { CHAPTERS } from "@/data";

export default function Bookmarks({ value, onChange }) {
    return (
        <nav className="bookmarks" data-testid="bookmarks-nav">
            {CHAPTERS.map((c, i) => {
                const active = c.id === value;
                return (
                    <motion.button
                        key={c.id}
                        type="button"
                        data-testid={`bookmark-${c.id}`}
                        onClick={() => onChange(c.id)}
                        initial={{ x: -70, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.4 + i * 0.09, type: "spring", stiffness: 130, damping: 17 }}
                        className={`bookmark ${active ? "bookmark-active" : ""}`}
                        title={c.label}
                        aria-label={c.label}
                        aria-current={active ? "page" : undefined}
                    >
                        <span className="bookmark-numeral">{c.numeral}</span>
                        <span className="bookmark-label">{c.label}</span>
                    </motion.button>
                );
            })}
        </nav>
    );
}
